import MainContent from '../../components/mainContent/MainContent';
import { RvMailContent } from './components/RvMailContent';

export default function ReenviarMail() {
    return (
        <MainContent
            component={<RvMailContent />}
            titulo='Reenviar Mail'
            noBackground
            tableMaxWidth
        />
    );
}